import CssBaseline from "@mui/material/CssBaseline";
import { StyledEngineProvider } from "@mui/material/styles";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import numeral from "numeral";
import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";

import { DocumentHead } from "src/components/DocumentHead";
import { SsoWrapper } from "src/containers/SsoWrapper";
import { LoadingBarProvider } from "src/contexts";
import { queryClient } from "src/libs";
import { initializeAnalytics } from "src/utils";

import { BrandWrapper } from "./BrandWrapper";
import { DatePickerProvider } from "./DatePickerProvider";
import ErrorBoundary, { ErrorFallback } from "./ErrorBoundary";
import Router from "./Router";
import { ThemeProvider } from "./ThemeProvider";
import "numeral/locales/fr";

numeral.locale("fr");

const App = () => {
  useEffect(() => initializeAnalytics(), []);

  return (
    <>
      <HelmetProvider>
        <StyledEngineProvider injectFirst>
          <ThemeProvider>
            <CssBaseline />
            <DatePickerProvider>
              <ErrorBoundary fallbackComponent={ErrorFallback}>
                <QueryClientProvider client={queryClient}>
                  <ReactQueryDevtools initialIsOpen={false} />
                  <SsoWrapper>
                    <LoadingBarProvider>
                      <BrandWrapper>
                        <DocumentHead />
                        <Router />
                      </BrandWrapper>
                    </LoadingBarProvider>
                  </SsoWrapper>
                </QueryClientProvider>
              </ErrorBoundary>
            </DatePickerProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </HelmetProvider>
    </>
  );
};

export default App;
